import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Downloads from './components/Downloads';
import Benefits from './components/Benefits';
import Process from './components/Process';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SeoSchema from './components/SeoSchema';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoSchema />
      <Hero />
      <About />
      <Services />
      <Downloads />
      <Benefits />
      <Process />
      <FAQ />
      <Contact />
      <Footer />

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/56944540956"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform duration-300 hover:scale-110 cursor-pointer"
        style={{ backgroundColor: '#25D366' }}
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl flex items-center justify-center w-8 h-8"></i>
      </a>
    </div>
  );
}
